import React from 'react'
import styles from './Home.module.css'
import BookingSection from '@/components/booking/BookingSection'

/**
 * Home Page — Diagnostic Appointment Portal
 * Features:
 *   - Two-input appointment booking form (Name & Mobile Number)
 *   - OTP verification with resend cooldown timer
 *   - Professional data usage and clinical privacy consent
 *   - Instant appointment scheduling receipt with Reception ID
 *   - Enterprise error handling with swift recovery options
 */
const HomePage: React.FC = () => {
  return (
    <main className={styles.homePage} id="main-content" aria-label="Main content">
      <BookingSection />
    </main>
  )
}

export default HomePage
